<template>
    <div class="no-results">
    <div class="message">
            <h2 class="title">Unfortunately, your search for “{{ query }}” returned no results.</h2>
    </div>
    <div class="helper">
        <ul>
            <li>Double Check your spelling for typos</li>
            <li>Use general product terms or fewer keywords</li>
            <li>Navigate to a product category using our site navigation</li>
            <li>Try searching for a product that is less specific and refine results</li>
        </ul>
        <div class="contact">
            <h3 class="title">Need additional assistance?<br/>We're here to help you.</h3>
            <a class="cta_button button" href="/company/contact-us">Contact ASC Today</a>
        </div>
    </div>
</div>
</template>
<script>
export default {
    props: {
        query: { default: 'the selected filters', type: String },
    }
}
</script>
